import './index.css'
import Button from '../button';
import { useState } from 'react';
import { generateNewIdea } from '../../functions/generateNewIdea';
import { generateNewPost } from '../../functions/generateNewPost';

function FeedItem({date,tag,site,url,title,expand,index,hasBeenSeen,display,desc,image,placeholder}){
    console.log(placeholder);
    const [displayedFeedImage, SetDisplayedFeedImage] = useState(null); // Initialize with fallback
    const getImage = async(searchMe) => {
        try {
            const domain = new URL(searchMe).hostname;
            const call = searchMe;
            let result = await fetch(call);
            if(result.ok){
                SetDisplayedFeedImage(call); // Update state with the fetched logo URL
            }
        } catch (error) {

        }
    };
    const [logo, setLogo] = useState('./images/fallback-logo.png'); // Initialize with fallback
    const getLogoUrl = async(searchMe) => {
        try {
            const domain = new URL(searchMe).hostname;
            const call = `https://logo.clearbit.com/${domain}`
            let result = await fetch(call);
            if(result.ok){
                setLogo(call); // Update state with the fetched logo URL
            }
            else{
                setLogo('./images/fallback-logo.png'); // Set fallback if the request fails
            }
        } catch (error) {
            setLogo('./images/fallback-logo.png'); // Set fallback if the request fails

        }
    };

    getLogoUrl(url);
    getImage(image);

    return <div className='feed-item-border' style={{display : 'flex'}}>
    <div className='feed-item new-post'>
    <div className='placeholder-tag tiny-text' style={{display : placeholder ? "block" : "none"}}>This is an example feed item.</div>
    <div className='date-and-tag-holder tiny-text'>
        <img className='feed-logo' src={logo} />
        <div className='feed-tag'><div style={{display : hasBeenSeen ? 'none' : 'block'}} className='new-content-globule'></div><div>{date}</div></div>
    </div>
    <img src={displayedFeedImage} style={{display : displayedFeedImage ? 'block' : 'none'}} />
    <h2 className='medium-text'>{title}</h2>
    <div className='text-holder'>
    <a href={url} target='_blank'><p className='url tiny-text'>{url}</p></a>
    <p className='tiny-text overview-excerpt'>{desc}</p>
    </div>
    <div className='action-bar'>
    <Button text='Generate blog' smallBool={true} addedFunction={generateNewIdea} params={{url:url,title:title,desc:desc,image:image}} />
    <Button text='Generate post' smallBool={true} addedFunction={generateNewPost} params={{url:url,title:title,desc:desc,image:image}}/>
    </div>
    </div>
    </div>
}

export default FeedItem